enum QuestionType {
    ShortText = `short-text`,
    LongText = `long-text`,
    Radio = `radio`,
    Multi = `multiple-choice`,
    Select = `select`
}

export default QuestionType